import debounce from 'lodash.debounce';
import { useMemo, useState } from 'react';
import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import ByProductEntryPoints from '#app/entrypoints/byProduct';
import { Option } from '#app/typings/utils';

type HookReturn = {
  byProducts: Option[];
  debouncedChange: (value: string) => void;
};

type Filters = {
  deposit?: string;
};

const useAutocompleteByProduct = (filters?: Filters): HookReturn => {
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const { data: byProducts } = useSWR<Option[]>(
    searchTerm
      ? generateApiPath(
          ByProductEntryPoints.autocomplete,
          {},
          {
            text: searchTerm,
            ...filters,
          },
        )
      : null,
    getCollection,
    {
      revalidateOnFocus: false,
    },
  );

  const handleChange = (value: string): void => {
    setSearchTerm(value);
  };

  const debouncedChange = useMemo(() => debounce(handleChange, 500), []);

  return {
    byProducts: byProducts ?? [],
    debouncedChange: debouncedChange,
  };
};

export default useAutocompleteByProduct;
